import { useEffect } from "react";

function upsertMeta(attr: "name" | "property", key: string, content: string): HTMLMetaElement {
  const sel = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(sel) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
  return el;
}

/** SEO / robots for a route. Restores previous title on unmount. */
export function usePageMeta(opts: {
  title: string;
  description?: string;
  robots?: string;
}): void {
  const { title, description, robots } = opts;

  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const prevDesc = document.head.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    const prevDescContent = prevDesc?.content ?? "";
    if (description) {
      upsertMeta("name", "description", description);
    }

    const prevRobots = document.head.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    const prevRobotsContent = prevRobots?.content ?? "";
    if (robots) {
      upsertMeta("name", "robots", robots);
    }

    return () => {
      document.title = prevTitle;
      if (description && prevDesc) {
        prevDesc.content = prevDescContent;
      } else if (description) {
        document.head.querySelector('meta[name="description"]')?.remove();
      }
      if (robots) {
        if (prevRobots && prevRobotsContent) {
          prevRobots.content = prevRobotsContent;
        } else {
          document.head.querySelector('meta[name="robots"]')?.remove();
        }
      }
    };
  }, [title, description, robots]);
}
